import { Box, Stack } from "@mui/material";
import { formatUsPhoneNumber } from "@src/appV2/lib/utils/formatPhoneNumber";
import { BottomSheetHeader } from "@src/appV2/redesign/components/BottomSheetHeader";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { BottomSheet, Text, type UseModalState } from "@src/appV2/redesign/system/ui-components";

import { type PlacementWithDetails } from "../../api/useFetchPaginatedPlacements";

interface PhoneConfirmationBottomSheetProps {
  modalState: UseModalState;
  phoneNumber: string;
  placementDetails: PlacementWithDetails;
  onConfirm: () => void;
  onUpdatePhone: () => void;
}

export function PhoneConfirmationBottomSheet(props: PhoneConfirmationBottomSheetProps) {
  const { modalState, phoneNumber, placementDetails, onConfirm, onUpdatePhone } = props;

  const formattedPhoneNumber = formatUsPhoneNumber(phoneNumber);

  const handleClose = () => {
    modalState.closeModal();
  };

  return (
    <BottomSheet
      modalState={modalState}
      header={<BottomSheetHeader onClose={handleClose} />}
      footer={
        <DialogFooter orientation="vertical">
          <Button fullWidth variant="contained" size="large" onClick={onConfirm}>
            Confirm phone number
          </Button>
          <Button
            fullWidth
            variant="outlined"
            size="large"
            sx={{ textDecoration: "underline", textUnderlineOffset: 4 }}
            onClick={onUpdatePhone}
          >
            This phone number is wrong
          </Button>
        </DialogFooter>
      }
      onClose={handleClose}
    >
      <Box sx={{ px: 5, py: 6 }}>
        <Stack spacing={6}>
          <Text semibold variant="h3">
            Confirm your number
          </Text>

          <Text variant="body1">
            Please review and confirm or correct the phone number on your account.
          </Text>

          <Text bold variant="h3" textAlign="center">
            {formattedPhoneNumber || phoneNumber}
          </Text>

          <Text variant="body1">
            {placementDetails.workplace.name} will use this number to call you at the time you
            schedule.
          </Text>

          <Text variant="body1">
            If the number is wrong, it could prevent you from moving forward in the hiring process.
          </Text>
        </Stack>
      </Box>
    </BottomSheet>
  );
}
